export enum TableEvents {
  filterChanged = 'filterChanged',
}

export const tableEvents = [TableEvents.filterChanged]
